<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Lead',
              modelPath: [this, 'form', 'lead'],
              required: true,
              type: 'emptyMenuBarInit'
            }),
            new fields.WYSIWYG({
              label: 'Tekst',
              modelPath: [this, 'form', 'text'],
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
